import React from 'react'
import * as R from 'ramda'

import { BUTTON, CHIP_GROUP, getContent, ICON_WITH_TEXT, TEXT } from './model'

export const Content = ({
  children,
  chips,
  chipsClassName,
  iconClassName,
  textClassName,
  icon,
  size = 24,
  type,
}) => {
  const Component = getContent(type)

  const mapContentToProps = {
    [BUTTON]: {},
    [CHIP_GROUP]: { chips, className: chipsClassName },
    [ICON_WITH_TEXT]: { icon, iconClassName, size, textClassName },
    [TEXT]: { className: textClassName },
  }

  if (R.isNil(Component)) return null

  return <Component {...mapContentToProps[type]}>{children}</Component>
}
